import React, { Component } from 'react';
import * as Connections from '../../../utils/Connections';
import { checkCookie } from '../../../utils/Cookies';
import AWS from 'aws-sdk';
import { Loader } from '../../../components/';
import ChatStore from '../../../stores/ChatStore';

class Line extends Component {
    state = {
        loading: false
    }
    componentDidMount() {
        this.setState({ loading: this.props.item.mType === "1" })
    }
    timeFormat = (sent) => {
        let time = new Date(sent)
        let minutes = "" + time.getMinutes();
        let hours = "" + time.getHours();
        if (minutes.length === 1) {
            minutes = "0" + minutes;
        }
        if (hours.length === 1) {
            hours = "0" + hours;
        }

        return `${time.getDate()}/${time.getMonth()} ${hours}:${minutes}`
    }
    render = () => {
        const { item } = this.props
        const isReceived = item.sender === "0";
        const isText = item.mType === "0";
        const { loading } = this.state
        return (
            <div className="message-line-container" style={{ width: "100%", display: "flex", justifyContent: isReceived ? "flex-start" : "flex-end" }}>
                <div>
                    <div style={{ borderRadius: 10, padding: "2px 8px", backgroundColor: isReceived ? 'black' : 'green', color: 'white', fontSize: 15, maxWidth: 150, overflowWrap: 'break-word' }}>
                        {
                            isText ? item.text :
                                <img onLoadCapture={() => this.setState({ loading: false })} alt="chat" src={item.text} style={{ width: "100%", height: "auto", margin: "6px 0", display: loading ? "none" : "block" }} />
                        }
                        {
                            loading && <Loader type="imageLoad" color="white" />
                        }
                    </div>
                    <div style={{ fontSize: 9, textAlign: isReceived ? "left" : "right" }}>{this.timeFormat(item.sent)}</div>
                </div>
            </div>
        )
    }
}
const imageMaxSize = 1000000000 // bytes

const acceptedFileTypes = 'image/x-png, image/png, image/jpg, image/jpeg, image/gif'

const acceptedFileTypesArray = acceptedFileTypes.split(",").map((item) => { return item.trim() })

export default class ViewMessage extends Component {
    state = {
        messages: [],
        myMessage: ""
    }
    componentDidMount() {
        this.getMessages();
        Connections.socket.on("newMessage", () => {
            this.getMessages();
        })
        ChatStore.on("change",()=>{
            const data=ChatStore.getChatObject()
            this.getMessages(data.userId);
        });
    }
    getMessages(id) {
        const userId = id?id:this.props.userId
        Connections.getFarmerChat(userId).then(({ messages }) => {
            this.setState({ messages }, () => {
                this.messagesEnd.scrollIntoView();
            })
        })
    }
    sendMessage(mType = "0") {
        const { myMessage, messages } = this.state;
        const farmerId = this.props.userId;
        if (myMessage.length > 0) {
            Connections.socket.emit('dashboardSendMessage', {
                farmerId,
                token: checkCookie("accessToken"),
                messageText: myMessage,
                messageType: mType,
                company: checkCookie("company").toLocaleLowerCase()
            })
            let newMessage = {
                farmerId,
                messageType: mType,
                mType,
                sender: "1",
                sent: new Date(),
                text: myMessage
            }
            messages.push(newMessage)
            this.setState({ myMessage: "" }, () => {
                this.messagesEnd.scrollIntoView();
            })
        }
    }

    verifyFile = (files) => {
        if (files && files.length > 0) {
            const currentFile = files[0]
            const currentFileType = currentFile.type
            const currentFileSize = currentFile.size
            if (currentFileSize > imageMaxSize) {
                alert("This file is not allowed. " + currentFileSize + " bytes is too large")
                return false
            }
            if (!acceptedFileTypesArray.includes(currentFileType)) {
                alert("This file is not allowed. Only images are allowed.")
                return false
            }
            return true
        }
    }
    handleFileSelect = async event => {
        const files = event.target.files
        console.log(files)

        if (files && files.length > 0) {
            const isVerified = this.verifyFile(files)
            if (isVerified) {
                const currentFile = files[0]
                AWS.config.update({
                    accessKeyId: "AKIAIACWY5ONFPAKUJFA",
                    secretAccessKey: "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",
                    region: "us-east-1",
                });
                let s3 = new AWS.S3();
                let params = {
                    Bucket: 'khula-farmer-profiles',
                    Body: currentFile,//fs.createReadStream('./wassup.png'),
                    Key: "chat/" + Date.now() + "_.png"
                };
                await s3.upload(params, (err, data) => {
                    //handle error
                    if (err) {
                        console.log("Error", err);
                    }
                    this.setState({
                        myMessage: data.Location
                    }, () => {
                        this.sendMessage("1")
                    })
                    return data.Location;
                });
            }
        }
    }

    render() {
        const acceptedFileTypes = 'image/x-png, image/png, image/jpg, image/jpeg, image/gif'
        const { messages } = this.state
        return (
            <div style={{ width: "100%", height: "100%", display: 'flex', flexDirection: 'column' }}>
                <div style={{ flex: 1, padding: "5px 8px", height: 330, overflow: "scroll" }}>
                    {
                        messages.map((item, i) =>
                            <Line key={i} item={item} />
                        )
                    }
                    <div ref={el => { this.messagesEnd = el; }} />
                </div>
                <div style={{ display: 'flex', alignItems: 'center', paddingBottom: 10, height: 35 }}>
                    <input value={this.state.myMessage} onKeyUp={(e) => e.keyCode === 13 ? this.sendMessage("0") : null} onChange={(e) => this.setState({ myMessage: e.target.value })} className="round" style={{ flex: 1, outline: 0, borderRadius: '25px', paddingLeft: 5, paddingRight: 5, marginLeft: 5, marginRight: 5, backgroundColor: 'rgba(0,255,0,0.15)' }} placeholder="Type a message..." multiple={true} />
                    <div onClick={() => this.sendMessage("0")} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', borderRadius: "100%", width: 25, height: 25, backgroundColor: "#080", cursor: "pointer", marginLeft: 5, marginRight: 5, }}>
                        <i className="lnr lnr-location" />
                    </div>
                    <div onClick={() => this.imageInputRef.click()} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', borderRadius: "100%", width: 25, height: 25, backgroundColor: "#080", cursor: "pointer", marginLeft: 5, marginRight: 5, }}>
                        <i className="lnr lnr-paperclip" />
                    </div>
                    <input style={{ display: "none" }} type="file" ref={(r) => this.imageInputRef = r} multiple={false} accept={acceptedFileTypes} onChange={this.handleFileSelect} />
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/HomePageBabies/BabyItems/ViewMessage.js